/* eslint-disable max-len */

import { Component } from "preact";
import { connect } from "preact-redux";
import style from "./style.scss";
import Select from "../select";
import ActivitiesMap from "../activities-map";
import PieChart from "../pie-chart";
import YearSelector from "../yearSelector";
import filterActions from "../../shared/actions/getFiltersData";
import pieChartActions from "../../shared/actions/getPieChartData";
import { getHomeMapData } from "../../shared/actions/mapActions/getHomeMapData";
import { getHomeMapSummaryData } from "../../shared/actions/getHomeMapSummaryData";
import { getHomeDonorsContributionsList } from "../../shared/actions/getHomeDonorsContributionsList";
import { formatNumber, formatNumberNoFractionDigits } from "../../utils";
import {
  updateYearList,
  setCurrentYear,
} from "../../shared/actions/getYearList";
const adaptPieChartData = (data) =>
  data.sectors
    ? {
        datasets: [
          {
            data: data.sectors.map((item) => item.percentage),
            backgroundColor: data.sectors.map((item) => `#${item.color}`),
          },
        ],
        titles: data.sectors.map((item) => item.name),
        labels: data.sectors.map(
          (item) =>
            `Budget: $${(item.budget / 1000000).toLocaleString("en", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}M | Expense: $${(item.expense / 1000000).toLocaleString("en", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}M`
        ),
      }
    : [];

const getPieChartTotalValue = (data) =>
  data.sectors
    ? data.sectors.reduce((total, item) => total + item.expense, 0)
    : 0;

const adaptPieChartLegend = (data) => (data.sectors ? data.sectors : []);

class HomeMapWithTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      field: undefined,
      donor: undefined,
      sdg: undefined,
      sector: undefined,
      year: this.props.year,
      selectedTab: 0,
    };
    this.onSelectField = this.onSelectField.bind(this);
    this.onSelectYear = this.onSelectYear.bind(this);
    this.onSelectTab = this.onSelectTab.bind(this);
    this.onSelectDonor = this.onSelectDonor.bind(this);
    this.onSelectSdg = this.onSelectSdg.bind(this);
    this.onSelectSector = this.onSelectSector.bind(this);
  }

  componentDidMount() {
    this.props.getHomeMapData(this.state.year, this.state.field);
    this.props.getHomeMapSummaryData(this.state.year, this.state.field);
  }

  onSelectField(field) {
    this.setState({ field });
    switch (this.state.selectedTab) {
      case 0:
        this.props.getHomeMapData(this.state.year, field);
        this.props.getHomeMapSummaryData(this.state.year, field);
        break;
      case 1:
        this.props.getHomeMapData(this.state.year, field, this.state.donor);
        this.props.getHomeMapSummaryData(
          this.state.year,
          field,
          this.state.donor
        );
        this.props.getHomeDonorsContributionsList(
          this.state.year,
          field,
          this.state.donor
        );
        break;
      case 2:
        this.props.getHomeMapData(this.state.year, field);
        this.props.getHomeMapSummaryData(this.state.year, field);
        this.props.getHomePortalsPieChartData(this.state.year, field);
        break;
      case 3:
        this.props.getHomeMapData(
          this.state.year,
          field,
          undefined,
          this.state.sdg
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          field,
          undefined,
          this.state.sdg
        );
        this.props.getHomeSdgsPieChartData(this.state.year, field);
        break;
      case 4:
        this.props.getHomeMapData(
          this.state.year,
          field,
          undefined,
          this.state.sector
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          field,
          undefined,
          this.state.sector
        );
        this.props.getHomeSectorsPieChartData(this.state.year, field);
        break;
      default:
        break;
    }
  }

  onSelectDonor(donor) {
    this.setState({ donor });
    switch (this.state.selectedTab) {
      case 1:
        this.props.getHomeMapData(this.state.year, this.state.field, donor);
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          donor
        );
        this.props.getHomeDonorsContributionsList(
          this.state.year,
          this.state.field,
          donor
        );
        break;
      default:
        break;
    }
  }

  onSelectYear(year) {
    this.setState({ year });
    this.props.setCurrentYear(year)

    switch (this.state.selectedTab) {
      case 0:
        this.props.getHomeMapData(this.state.year, this.state.field);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field);
        break;
      case 1:
        this.props.getHomeMapData(
          this.state.year,
          this.state.field,
          this.state.donor
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          this.state.donor
        );
        this.props.getHomeDonorsContributionsList(
          this.state.year,
          this.state.field,
          this.state.donor
        );
        break;
      case 2:
        this.props.getHomeMapData(this.state.year, this.state.field);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field);
        this.props.getHomePortalsPieChartData(
          this.state.year,
          this.state.field
        );
        break;
      case 3:
        this.props.getHomeMapData(
          this.state.year,
          this.state.field,
          undefined,
          this.state.sdg
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          undefined,
          this.state.sdg
        );
        this.props.getHomeSdgsPieChartData(this.state.year, this.state.field);
        break;
      case 4:
        this.props.getHomeMapData(
          this.state.year,
          this.state.field,
          undefined,
          this.state.sector
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          undefined,
          this.state.sector
        );
        this.props.getHomeSectorsPieChartData(
          this.state.year,
          this.state.field
        );
        break;
      default:
        break;
    }
  }

  onSelectSdg(sdg) {
    this.setState({ sdg });
    switch (this.state.selectedTab) {
      case 3:
        this.props.getHomeMapData(
          this.state.year,
          this.state.field,
          undefined,
          sdg
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          undefined,
          sdg
        );
        this.props.getHomeSdgsPieChartData(
          this.state.year,
          this.state.field,
          sdg
        );
        break;
      default:
        break;
    }
  }

  onSelectSector(sector) {
    this.setState({ sector });
    switch (this.state.selectedTab) {
      case 4:
        this.props.getHomeMapData(
          this.state.year,
          this.state.field,
          undefined,
          sector
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          undefined,
          sector
        );
        this.props.getHomeSectorsPieChartData(
          this.state.year,
          this.state.field,
          sector
        );
        break;
      default:
        break;
    }
  }

  onSelectTab(selectedTab) {
    this.setState({ selectedTab });
    switch (selectedTab) {
      case 0:
        this.props.getHomeMapData(this.state.year, this.state.field);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field);
        break;
      case 1:
        this.props.getHomeMapData(
          this.state.year,
          this.state.field,
          this.state.donor
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          this.state.donor
        );
        this.props.getHomeDonorsContributionsList(
          this.state.year,
          this.state.field,
          this.state.donor
        );
        break;
      case 2:
        this.props.getHomeMapData(this.state.year, this.state.field);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field);
        this.props.getHomePortalsPieChartData(
          this.state.year,
          this.state.field
        );
        break;
      case 3:
        this.props.getHomeMapData(
          this.state.year,
          this.state.field,
          undefined,
          this.state.sdg
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          undefined,
          this.state.sdg
        );
        this.props.getHomeSdgsPieChartData(this.state.year, this.state.field);
        break;
      case 4:
        this.props.getHomeMapData(
          this.state.year,
          this.state.field,
          undefined,
          this.state.sector
        );
        this.props.getHomeMapSummaryData(
          this.state.year,
          this.state.field,
          undefined,
          this.state.sector
        );
        this.props.getHomeSectorsPieChartData(
          this.state.year,
          this.state.field
        );
        break;
      default:
        break;
    }
  }

  render() {
    const {
      homeFields,
      getHomeFields,
      homeMapData,
      homeMapSummaryData,
      getHomeDonors,
      homeDonors,
      homeDonorsContributionsList,
      homePortalsPieChartData,
      getHomeSdgs,
      homeSdgs,
      homeSdgsPieChartData,
      homeSectors,
      homeSectorsPieChartData,
      getHomeSectors,
    } = this.props;
    const { field, year, selectedTab } = this.state;
    return (
      <div>
        <div className={style.mainWrapper}>
          <div className={style.mainTitleWrapper}>
            <h1>Explore</h1>
            <span>
              Learn more about where and how UNRWA is making a difference
            </span>
          </div>
          <div className={style.tabsWrapper}>
            <ul>
              <li
                className={selectedTab === 0 ? style.active : undefined}
                onClick={() => this.onSelectTab(0)}
              >
                Fields of operations
              </li>
              <li
                className={selectedTab === 1 ? style.active : undefined}
                onClick={() => this.onSelectTab(1)}
              >
                Donors
              </li>
              <li
                className={selectedTab === 2 ? style.active : undefined}
                onClick={() => this.onSelectTab(2)}
              >
                Portals
              </li>
              <li
                className={selectedTab === 4 ? style.active : undefined}
                onClick={() => this.onSelectTab(4)}
              >
                Sectors
              </li>
              <li
                className={selectedTab === 3 ? style.active : undefined}
                onClick={() => this.onSelectTab(3)}
              >
                SDGs
              </li>
            </ul>
          </div>
          <div className={style.filtersMainWrapper}>
            <div className={style.filtersWrapper}>
            <div className={style.yearSelectorWrapper}>
              <YearSelector
                selectedYear={this.props.globalSelectedYear}
                onSelectYear={this.onSelectYear}
              />
            </div>
              <div>
                <Select
                  label="Field of operations"
                  onFilter={getHomeFields}
                  onSelect={this.onSelectField}
                  options={homeFields.map((item) => ({
                    key: item.code,
                    label: item.name,
                    value: item.name,
                  }))}
                />
              </div>
              {selectedTab === 1 ? (
                <div>
                  <Select
                    label="Donors"
                    onFilter={getHomeDonors}
                    onSelect={this.onSelectDonor}
                    options={homeDonors.map((item) => ({
                      key: item.code,
                      label: item.name,
                      value: item.code,
                    }))}
                  />
                </div>
              ) : (
                <div />
              )}
            </div>
            <div style={{ display: "none" }} className={style.exportWrapper}>
              <i className="fas fa-download" />
              <span>Export</span>
            </div>
          </div>
          <div className={style.mapWrapper}>
            <ActivitiesMap mapData={homeMapData} />
            {homeMapData.data.length ? (
              <div className={style.summaryDataWrapper}>
                <div>
                  {field ? (
                    <b>
                      <a href={`/profile/${field}/recipientprofile`}>{field}</a>
                    </b>
                  ) : (
                    <b>Global</b>
                  )}
                </div>
                <div>
                  <div>
                    <b>{formatNumber(homeMapSummaryData.budgets / 1000000)}m</b>
                    <span>Budget</span>
                  </div>
                  <div>
                    <b>
                      {formatNumber(homeMapSummaryData.expenses / 1000000)}m
                    </b>
                    <span>Expense</span>
                  </div>
                  <div>
                    <b>
                      {formatNumberNoFractionDigits(
                        homeMapSummaryData.activities
                      )}
                    </b>
                    <span>Activities</span>
                  </div>
                  <div>
                    <b>
                      {formatNumberNoFractionDigits(homeMapSummaryData.donors)}
                    </b>
                    <span>Donors</span>
                  </div>
                </div>
                {selectedTab === 1 && homeDonorsContributionsList.donors ? (
                  <div className={style.contributionsWrapper}>
                    {homeDonorsContributionsList.donors.map((item) => (
                      <div
                        key={`donor_contribution_${item.donor_code}`}
                        className={style.contributionRowWrapper}
                      >
                        <a
                          href={`/profile/${item.donor_code}/donorprofile`}
                          alt={item.donor_name}
                        >
                          <h4>{item.donor_name}</h4>
                        </a>
                        <div className={style.contributionSummaryWrapper}>
                          <b>{`${formatNumber(
                            item.contributions / 1000000
                          )}m`}</b>
                          <small>Contributions</small>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div />
                )}
                {selectedTab === 2 &&
                homePortalsPieChartData.data.sectors &&
                homePortalsPieChartData.data.sectors.length ? (
                  <div className={style.portalsChartWrapper}>
                    <PieChart
                      title="Total Budget"
                      data={adaptPieChartData(homePortalsPieChartData.data)}
                      legendData={adaptPieChartLegend(
                        homePortalsPieChartData.data
                      )}
                      loading={homePortalsPieChartData.loading}
                      totalValue={getPieChartTotalValue(
                        homePortalsPieChartData.data
                      )}
                    />
                  </div>
                ) : (
                  <div />
                )}
                {selectedTab === 3 &&
                homeSdgsPieChartData.data.sectors &&
                homeSdgsPieChartData.data.sectors.length ? (
                  <div className={style.sdgsChartWrapper}>
                    <PieChart
                      title="Total Budget"
                      data={adaptPieChartData(homeSdgsPieChartData.data)}
                      legendData={adaptPieChartLegend(
                        homeSdgsPieChartData.data
                      )}
                      loading={homeSdgsPieChartData.loading}
                      totalValue={getPieChartTotalValue(
                        homeSdgsPieChartData.data
                      )}
                    />
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "0.85rem",
                        padding: "1.5rem 3rem",
                      }}
                    >
                      * SDG mapping is provided only for non-humanitarian
                      activities
                    </div>
                  </div>
                ) : (
                  <div />
                )}
                {selectedTab === 4 &&
                homeSectorsPieChartData.data.sectors &&
                homeSectorsPieChartData.data.sectors.length ? (
                  <div className={style.sectorsChartWrapper}>
                    <PieChart
                      title="Total Budget"
                      data={adaptPieChartData(homeSectorsPieChartData.data)}
                      legendData={adaptPieChartLegend(
                        homeSectorsPieChartData.data
                      )}
                      loading={homeSectorsPieChartData.loading}
                      totalValue={getPieChartTotalValue(
                        homeSectorsPieChartData.data
                      )}
                    />
                  </div>
                ) : (
                  <div />
                )}
              </div>
            ) : (
              <div />
            )}
           
          </div>
        </div>
        <div class={style.disclaimerText}>
          {
            "* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of the Secretariat of the United Nations or UNRWA concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries. State of Palestine includes West Bank, East Jerusalem and the Gaza Strip."
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    homeFields: state.homeFields.data,
    homeDonors: state.homeDonors.data,
    homeSdgs: state.homeSdgs.data,
    homeSectors: state.homeSectors.data,
    homeMapData: state.homeMapData,
    homeMapSummaryData: state.homeMapSummaryData.data,
    homeDonorsContributionsList: state.homeDonorsContributionsList.data,
    year: state.yearList.currentYear,
    homePortalsPieChartData: state.homePortalsPieChartData,
    homeSdgsPieChartData: state.homeSdgsPieChartData,
    homeSectorsPieChartData: state.homeSectorsPieChartData,
    globalSelectedYear:state.yearList.currentYear,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getHomeFields: (filter) => dispatch(filterActions.getHomeFields(filter)),
    getHomeDonors: (filter) => dispatch(filterActions.getHomeDonors(filter)),
    getHomeSdgs: (filter) => dispatch(filterActions.getHomeSdgs(filter)),
    getHomeSectors: (filter) => dispatch(filterActions.getHomeSectors(filter)),
    getHomeMapData: (year, field, donor, vocabulary) =>
      dispatch(getHomeMapData(year, field, donor, vocabulary)),
    getHomeMapSummaryData: (year, field, donor, vocabulary) =>
      dispatch(getHomeMapSummaryData(year, field, donor, vocabulary)),
    getHomeDonorsContributionsList: (year, field, donor) =>
      dispatch(getHomeDonorsContributionsList(year, field, donor)),
    getHomePortalsPieChartData: (year, field) =>
      dispatch(pieChartActions.getHomePortalsPieChartData(year, field)),
    getHomeSdgsPieChartData: (year, field) =>
      dispatch(pieChartActions.getHomeSdgsPieChartData(year, field, 7)),
    getHomeSectorsPieChartData: (year, field) =>
      dispatch(pieChartActions.getHomeSectorsPieChartData(year, field, 2)),
    setCurrentYear: (year) => dispatch(setCurrentYear(year)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeMapWithTabs);



// WEBPACK FOOTER //
// ./components/home-map-with-tabs/index.js